export const GET_MY_SOURCES = "GET_MY_SOURCES";
export const SET_MY_SOURCES = "SET_MY_SOURCES";
export const SET_A_SOURCE = "SET_A_SOURCE";
export const GET_A_SOURCE = "GET_A_SOURCE";
export const VALIDATE_A_SOURCE = "VALIDATE_A_SOURCE";
export const REJECT_A_SOURCE = "REJECT_A_SOURCE";